import { render } from "./Login2.vue?vue&type=template&id=8df6fba6&scoped=true"
import script from "./Login2.vue?vue&type=script&lang=js"
export * from "./Login2.vue?vue&type=script&lang=js"

import "./Login2.vue?vue&type=style&index=0&id=8df6fba6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8df6fba6"]])

export default __exports__